import { BarsArrowUpIcon } from '@heroicons/react/20/solid'
import styles from './SortBar.module.scss'

export const SortBar = ({ isNewestFirst, onToggle }) => {
	return (
		<div className={styles.sortBar}>
			<BarsArrowUpIcon style={{ width: '14px', height: '14px', color: '#A0A0A0' }} />
			<span className={styles.sort} onClick={onToggle}>
				{isNewestFirst ? '최신순' : '오래된 순'}
			</span>
		</div>
	)
}
